import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import AppShell from "@/components/AppShell";

import Dashboard from "@/pages/distributor/Dashboard";
import DistributorBranding from "@/pages/distributor/ProfileBrand";
import DistributorCatalog from "@/pages/distributor/Catalog";
import Logistics from "@/pages/distributor/Logistics";
import Pricing from "@/pages/distributor/Pricing";
import BI from "@/pages/distributor/BI";
import VendorPlants from "@/pages/distributor/VendorPlants";
import CustomersManage from "@/pages/shared/CustomersManage";

// Re-use existing role-agnostic pages
import FinishedProducts from "@/pages/inventory/FinishedProducts";
import Stock from "@/pages/inventory/Stock";
import PurchaseOrders from "@/pages/procurement/PurchaseOrders";
import GRN from "@/pages/procurement/GRN";
import Finance from "@/pages/finance/Finance";
import DistributorDispatch from "@/pages/distributor/DistributorDispatch";
import DistributorCollections from "@/pages/distributor/DistributorCollections";
import PortalTeam from "@/components/PortalTeam";
import AuditLog from "@/pages/settings/AuditLog";
import MfaSettings from "@/pages/settings/Mfa";

export default function DistributorDashboard() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return (
    <AppShell variant="distributor">
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/branding" element={<DistributorBranding />} />
        <Route path="/catalog" element={<DistributorCatalog />} />
        <Route path="/inventory/products" element={<FinishedProducts />} />
        {/* legacy paths → redirect */}
        <Route path="/inventory/items" element={<Navigate to="/distributor/inventory/products" replace />} />
        <Route path="/bulk-orders/requisitions" element={<Navigate to="/distributor/dispatch" replace />} />
        <Route path="/dealers" element={<Navigate to="/distributor" replace />} />
        <Route path="/inventory/stock" element={<Stock />} />
        <Route path="/bulk-orders/po" element={<PurchaseOrders />} />
        <Route path="/bulk-orders/grn" element={<GRN />} />
        <Route path="/dispatch" element={<DistributorDispatch />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/customers" element={<CustomersManage title="Customers" subtitle="Retail and B2B customers this distributor sells to." />} />
        <Route path="/vendor-plants" element={<VendorPlants />} />
        <Route path="/logistics" element={<Logistics />} />
        <Route path="/payments" element={<Finance />} />
        <Route path="/collections" element={<DistributorCollections />} />
        <Route path="/team" element={<PortalTeam portal="DISTRIBUTOR" title="Team & staff" />} />
        <Route path="/bi" element={<BI />} />
        <Route path="/audit" element={<AuditLog />} />
        <Route path="/settings/mfa" element={<MfaSettings />} />
      </Routes>
    </AppShell>
  );
}
